import { render, staticRenderFns } from "./PropertiesTable.vue?vue&type=template&id=65803ebc&scoped=true"
import script from "./PropertiesTable.vue?vue&type=script&lang=ts"
export * from "./PropertiesTable.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesTable.vue?vue&type=style&index=0&id=65803ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65803ebc",
  null
  
)

export default component.exports